import { getservice } from "../services/crudservice";
import { store } from "..";
const assignHandler = payload => {
  var myinfo = store.getState().myinfo.employeeinfo;
  var payload_index = payload.findIndex(p => p.empnumber === myinfo.empnumber);
  if (payload_index > -1) {
    getservice("edfemployees", myinfo.empnumber)
      .then(myinfo => {
        console.log("Handling new Assignment", myinfo);

        store.dispatch({
          type: "RealTimeUpdate for myrealtimeinfo",
          payload: myinfo
        });
      })
      .catch(err => console.log("Handling new Assignment Fail", err));
  }
};
const empHandler = payload => {
  var myinfo = store.getState().myinfo.employeeinfo;

  var payload_index = payload.findIndex(p => p.empnumber === myinfo.empnumber);
  if (payload_index > -1) {
    getservice("edfemployees", myinfo.empnumber)
      .then(myinfo => {
        console.log("Handling new EmpInfo", myinfo);

        store.dispatch({
          type: "RealTimeUpdate for myrealtimeinfo",
          payload: myinfo
        });
      })
      .catch(err => console.log("Handling new EmpInfo Fail", err));
  }
};
export default { assign: assignHandler, employee: empHandler };



// WEBPACK FOOTER //
// ./src/actions/realtime-handler.js